import { render, staticRenderFns } from "./smsTemplateOverview.vue?vue&type=template&id=33214210&scoped=true&"
import script from "./smsTemplateOverview.vue?vue&type=script&lang=js&"
export * from "./smsTemplateOverview.vue?vue&type=script&lang=js&"
import style0 from "./smsTemplateOverview.vue?vue&type=style&index=0&id=33214210&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33214210",
  null
  
)

export default component.exports